import {Map} from 'immutable';
import * as action from '../actions';


const initialState = Map({
	connected: false,
});

const actionHandlers = {
	[action.socketServerOn]: state => {
		// console.log('socket server: on');
		return state.merge({
			connected: true,
		});
	},
	[action.socketServerOff]: state => {
		// console.log('socket server: off');
		return state.merge({
			connected: false,
		});
	},
};

export {initialState, actionHandlers};
export default createReducer => createReducer(initialState, actionHandlers);



// WEBPACK FOOTER //
// ./src/reducers/socketReducer.js